import { render } from "./MessageReceiversViewMore.vue?vue&type=template&id=2b82045a&scoped=true"
import script from "./MessageReceiversViewMore.vue?vue&type=script&lang=js"
export * from "./MessageReceiversViewMore.vue?vue&type=script&lang=js"

import "./MessageReceiversViewMore.vue?vue&type=style&index=0&id=2b82045a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b82045a"]])

export default __exports__